module.exports = __webpack_public_path__ + "03_face.742f1604.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer1/03_face.png
// module id = Mbhs
// module chunks = 0